import TextEditor, {
  MentionItem,
  VariableItem,
} from "@/modules/ckeditor/TextEditor";
import TextEditorUtils from "@/modules/ckeditor/TextEditorUtils";
import classNames from "classnames";
import SplitPane from "react-split-pane";
import ValidationPopover, {
  ValidatorPopoverStyle,
} from "../../general/ValidationPopover/ValidationPopover";
import LabeledInput from "../LabeledInput";
import "./BFDocumentEditor.scss";
import BFDocumentView from "./BFDocumentView";

interface BFDocumentEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
  labelSuffix?: React.ReactNode;
  labelPosition?: "top" | "left";
  info?: React.ReactNode;
  placeholder?: string;
  validation?: {
    message: string;
    level: "error" | "warning";
  };
  validatorStyle?: ValidatorPopoverStyle;
  height?: number | string;
  prefixHtml?: string;
  suffixHtml?: string;
  letter?: boolean;
  allowPagebreak?: boolean;

  mentionSource?: (search: string) => Promise<MentionItem[]>;
  variableSource?: (search: string) => Promise<VariableItem[]>;
  allowPlaceholders?: boolean;
  resolvedVariables?: { [key: string]: string };
  conditions?: { [key: string]: boolean };
  resolvedVariableFormatters?: { [key: string]: (value: any) => string };
}
const BFDocumentEditor = (props: BFDocumentEditorProps) => {
  return (
    <LabeledInput
      label={props.label}
      info={props.info}
      labelPosition={props.labelPosition}
      suffix={props.labelSuffix}
      error={!!props.validation?.message}
    >
      <ValidationPopover
        validatorStyle={props.validatorStyle}
        level={props.validation ? props.validation.level : "error"}
        message={props.validation ? props.validation.message : null}
        marginTop={0}
      >
        <div
          className={classNames(`bf-document-editor`)}
          style={{
            height: props.height || 500,
          }}
        >
          <SplitPane
            split={"vertical"}
            defaultSize={"50%"}
            maxSize={-200}
            primary="first"
            minSize={150}
            allowResize
          >
            <div className={`text-container`}>
              <TextEditor
                mentionSource={props.mentionSource}
                variableSource={props.variableSource}
                allowPlaceholders={props.allowPlaceholders}
                disabled={props.disabled}
                placeholder={props.placeholder}
                onChange={(value) => props.onChange(value)}
                value={props.value}
                allowPagebreak={props.allowPagebreak}
              />
            </div>
            <div className={`pdf-container`}>
              <BFDocumentView
                contentHtml={
                  <>
                    {props.prefixHtml && (
                      <div
                        className={`prefix-html`}
                        dangerouslySetInnerHTML={{
                          __html: TextEditorUtils.replaceVariables(
                            props.prefixHtml,
                            props.resolvedVariables || {},
                            {
                              conditions: props.conditions,
                              formatFunctions: props.resolvedVariableFormatters,
                            }
                          ),
                        }}
                      />
                    )}
                    <div
                      className={`value-html`}
                      dangerouslySetInnerHTML={{
                        __html: TextEditorUtils.replaceVariables(
                          props.value || "",
                          props.resolvedVariables || {},
                          {
                            conditions: props.conditions,
                            formatFunctions: props.resolvedVariableFormatters,
                          }
                        ),
                      }}
                    />

                    {props.suffixHtml && (
                      <div
                        className={`suffix-html`}
                        dangerouslySetInnerHTML={{
                          __html: TextEditorUtils.replaceVariables(
                            props.suffixHtml,
                            props.resolvedVariables || {},
                            {
                              conditions: props.conditions,
                              formatFunctions: props.resolvedVariableFormatters,
                            }
                          ),
                        }}
                      />
                    )}
                  </>
                }
              />
            </div>
          </SplitPane>
        </div>
      </ValidationPopover>
    </LabeledInput>
  );
};

export default BFDocumentEditor;
